// -----------------------------------------------------------------------------
// actionMeta.js — shared action-type icon/label/color registry
//
// Single source of truth for all guided-checklist item types.
// Consumed by:
//   UpNextCard, ChecklistList, v2/UpNextCardV2, v2/ChecklistListV2
//
// Previously defined in FollowUpChecklistV2.jsx — moved here to avoid
// importing a heavy React component just to get a metadata object.
// FollowUpChecklistV2 re-exports both maps from here for backward compat.
// -----------------------------------------------------------------------------

export const ACTION_META = {
    EMAIL_SENT:          { icon: 'mdi:email',                 label: 'Email',         color: '#0071e3' },
    WHATSAPP_SENT:       { icon: 'ic:baseline-whatsapp',      label: 'WhatsApp',      color: '#25D366' },
    SMS_SENT:            { icon: 'mdi:message-text',          label: 'SMS',           color: '#5856d6' },
    PHONE_CALLED:        { icon: 'mdi:phone',                 label: 'Phone',         color: '#34c759' },
    LOG_PHONE_CALL:      { icon: 'mdi:phone-log',             label: 'Log call',      color: '#34c759' },
    SEND_CONSENT_FORM:   { icon: 'mdi:file-document-edit',    label: 'Consent form',  color: '#7B61FF' },
    SEND_REVIEW_REQUEST: { icon: 'mdi:star',                  label: 'Review',        color: '#FFAB00' },
    SEND_PAYMENT_LINK:   { icon: 'mdi:cash',                  label: 'Payment',       color: '#00AB55' },
    SEND_TREATMENT_PLAN: { icon: 'mdi:clipboard-text',        label: 'Plan',          color: '#0071e3' },
    ADD_NOTE:            { icon: 'mdi:note-text',             label: 'Note',          color: '#637381' },
    SCHEDULE_REMINDER:   { icon: 'mdi:bell',                  label: 'Reminder',      color: '#0071e3' },
    LEAD_NEXT_ACTION:    { icon: 'mdi:arrow-right-circle',    label: 'Next action',   color: '#5856d6' },
    BOOK_APPOINTMENT:    { icon: 'mdi:calendar-clock',        label: 'Book',          color: '#34c759' },
    CONFIRMATION:        { icon: 'mdi:check-circle',          label: 'Confirm',       color: '#34c759' },
    UPLOAD_DOCUMENT:     { icon: 'mdi:cloud-upload',          label: 'Upload',        color: '#637381' },
    LINKED_CHECKLIST:    { icon: 'mdi:link-variant',          label: 'Linked',        color: '#637381' },
    FREE_TEXT:           { icon: 'mdi:text-short',            label: 'Text',          color: '#637381' },
    MULTIPLE_CHOICE:     { icon: 'mdi:format-list-bulleted',  label: 'Choice',        color: '#637381' },
    YES_NO_TOGGLE:       { icon: 'mdi:toggle-switch',         label: 'Yes/No',        color: '#0071e3' },
    CURRENCY_AMOUNT:     { icon: 'mdi:currency-gbp',          label: 'Amount',        color: '#00AB55' },
    PAYMENT_METHOD:      { icon: 'mdi:credit-card-outline',   label: 'Payment',       color: '#00AB55' },
    STAFF_PICKER:        { icon: 'mdi:account-tie',           label: 'Staff',         color: '#7B61FF' },
    DATE_FIELD:          { icon: 'mdi:calendar',              label: 'Date',          color: '#0071e3' },
};

export const DEFAULT_ACTION_META = {
    icon:  'mdi:checkbox-marked-circle-outline',
    label: 'Step',
    color: '#6e6e73',
};

// Human-readable past-tense labels for the post-action confirmation card.
export const COMPLETION_LABELS = {
    EMAIL_SENT:          'Email sent',
    WHATSAPP_SENT:       'WhatsApp sent',
    SMS_SENT:            'SMS sent',
    PHONE_CALLED:        'Call logged',
    LOG_PHONE_CALL:      'Call logged',
    SEND_CONSENT_FORM:   'Consent sent',
    SEND_REVIEW_REQUEST: 'Review requested',
    SEND_PAYMENT_LINK:   'Payment link sent',
    SEND_TREATMENT_PLAN: 'Plan sent',
    ADD_NOTE:            'Note added',
    SCHEDULE_REMINDER:   'Reminder set',
    LEAD_NEXT_ACTION:    'Next action set',
    BOOK_APPOINTMENT:    'Appointment booked',
    CONFIRMATION:        'Confirmed',
    UPLOAD_DOCUMENT:     'Document uploaded',
    LINKED_CHECKLIST:    'Checklist opened',
    FREE_TEXT:           'Response recorded',
    MULTIPLE_CHOICE:     'Option selected',
    YES_NO_TOGGLE:       'Marked done',
    CURRENCY_AMOUNT:     'Amount recorded',
    PAYMENT_METHOD:      'Method set',
    STAFF_PICKER:        'Staff assigned',
    DATE_FIELD:          'Date set',
};
export const DEFAULT_COMPLETION_LABEL = 'Task completed';
